export const PUBLIC_ROOT = '/auth'
export const PRIVATE_ROOT = '/app'
export const HOME = `${PRIVATE_ROOT}/home`
export const DATABASE_MAINTENANCE = '/database-maintenance'
